import React, { FC, useCallback } from 'react';
import { IntegrationField } from 'api/integrations';
import { TextArea } from 'components/atoms/input';
import { useInput } from 'hooks/use-input';

type OnChangeParams = {
  integrationFieldId: string;
  valueStr?: string;
};

type IntegrationInputField = {
  field: IntegrationField;
  onChange?: (data: OnChangeParams) => void;
  value?: string;
  disabled?: boolean;
  placeholder?: string;
};

export const IntegrationMultiLineField: FC<IntegrationInputField> = ({
  field,
  onChange,
  value = '',
  placeholder = '',
  disabled,
}) => {
  const [input, onInputChange] = useInput(value);

  const handleOnBlur = useCallback(
    (_: React.FocusEvent<HTMLTextAreaElement>) => {
      if (onChange != null) {
        onChange({
          integrationFieldId: field.integrationFieldId,
          valueStr: input,
        });
      }
    },
    [onChange, field, input],
  );

  return (
    <TextArea
      autoSize
      placeholder={placeholder}
      value={input}
      onChange={onInputChange}
      onBlur={handleOnBlur}
      disabled={disabled}
    />
  );
};
